<template>
  <ProductPageLayout
    name="MtyZip"
    :logo="logo"
    :hero-image="heroImage"
    lead="Fast, reliable, lightweight compress and extract for office archives, batch transfer, and cross-device sharing."
    :feature-lines="featureLines"
    download-link="/ftp/packages/mtyzip/MtyZipSetup.exe"
    download-file-name="MtyZipSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="Compress, extract, preview, and special modes for faster archive workflows."
    other-desc="More tools for PDF, video, and split archives."
    reviews-desc="Real feedback that keeps improving MtyZip."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Compress',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/mtyzip/ziplogo48.png'),
      heroImage: require('@/assets/mtyzip/首页.png'),
      featureLines: [
        'Compress / extract / batch pack / archive preview',
        'PDF compress / image compress / video compress / split volumes'
      ],
      metaItems: [
        { icon: 'fast', label: 'Fast compress' },
        { icon: 'lock', label: 'Secure' },
        { icon: 'puzzle', label: 'Feature-rich' }
      ],
      detailedFeatures: [
        {
          title: 'Compress',
          brief: 'Multi-format archives in one click with balanced speed and size.',
          detail: 'Pack documents, assets, and project folders quickly to cut transfer and storage cost.',
          image: require('@/assets/mtyzip/文件压缩界面.jpg')
        },
        {
          title: 'Extract',
          brief: 'Stable extraction even for complex archives, with a clear process.',
          detail: 'Optimized for nested folders, batch extract, and large files — fewer interruptions in daily office work.',
          image: require('@/assets/mtyzip/文件解压过程.jpg')
        },
        {
          title: 'Image compress',
          brief: 'Smaller images with better clarity retention.',
          detail: 'Adjustable levels for docs, web assets, and messaging — balance quality and size.',
          image: require('@/assets/mtyzip/图片压缩界面.jpg')
        },
        {
          title: 'Archive preview',
          brief: 'Browse archive contents without full extract.',
          detail: 'See structure clearly, find the target file faster, and skip repeated unpack steps.',
          image: require('@/assets/mtyzip/主界面.jpg')
        }
      ],
      otherFeatures: [
        { title: 'PDF compress', description: 'Shrink PDFs for email and online submission.', icon: 'pdf' },
        { title: 'Video compress', description: 'Lower video size with controllable clarity.', icon: 'video' },
        { title: 'Split volumes', description: 'Split large archives for easier cross-device transfer.', icon: 'puzzle' },
        { title: 'Batch jobs', description: 'Process multiple folders and save repetitive clicks.', icon: 'iterate' }
      ],
      reviews: [
        { name: 'Blake', comment: 'Archiving packs is clearly faster; batch compress stays stable.', avatar: require('@/assets/mtyzip/avatar1.jpeg') },
        { name: 'Cameron', comment: 'Course and screen-capture packs are easy to share with students.', avatar: require('@/assets/mtyzip/avatar2.jpeg') },
        { name: 'Dana', comment: 'Extract is quick and the UI is simple — almost no learning curve.', avatar: require('@/assets/mtyzip/avatar3.jpeg') },
        { name: 'Elliot', comment: 'Split volumes helped a lot when campaign assets got huge.', avatar: require('@/assets/mtyzip/avatar4.jpeg') },
        { name: 'Finley', comment: 'Format coverage is enough for internal file sharing.', avatar: require('@/assets/mtyzip/avatar5.jpeg') },
        { name: 'Gray', comment: 'Image compress keeps quality; delivering assets is smoother.', avatar: require('@/assets/mtyzip/avatar6.jpeg') }
      ]
    }
  }
}
</script>
